import { PopulatedAssessment } from '../../types/app/populated'
import { ConfirmCoverageStatus, CoverageStageStatus } from '../../types/assessments/assessment'
import {
  BaseInsuranceCoverage,
  InsuranceCoverageRequest,
  isInsuranceCoverageRequest,
} from '../../types/insurance/coverage'
import { getHasPrimaryCoverage, getHasSecondaryCoverage } from '../../utils/assessments/coverage'
import { defaultStageValidate } from '../../utils/fields'
import { optInCallInField } from '../callIn/form'
import { getBasicInfoField, policyOwnerFieldMap } from './insuranceCoverage'

const getRequestStatus = ({ withCallInForm }: InsuranceCoverageRequest) => {
  const res: CoverageStageStatus = {
    incomplete: ['basic-info'],
    required: ['basic-info'],
  }
  if (withCallInForm) {
    res.incomplete.push('call-in')
    res.required.push('call-in')
  }
  res.incomplete.push('policy-owner')
  res.required.push('policy-owner')
  return res
}

export const getCoverageStatus = (
  coverage: BaseInsuranceCoverage | undefined | null,
  withCallIn: boolean,
  request?: InsuranceCoverageRequest,
): CoverageStageStatus => {
  if (coverage && isInsuranceCoverageRequest(coverage)) return getRequestStatus(coverage)
  const isMedicaid = !!coverage?.isMedicaid
  const basicInfoField = getBasicInfoField(isMedicaid)
  const basicInfoComplete = !defaultStageValidate(basicInfoField, true)(coverage ?? undefined)

  const hasCallInRequests =
    !!Object.keys(coverage?.callInRequests ?? {}).length || request?.withCallInForm
  const callInRequired = !isMedicaid && (withCallIn || hasCallInRequests)

  const callInComplete =
    !callInRequired || !defaultStageValidate(optInCallInField, true)(coverage ?? undefined)

  // const policyOwnerRequired = type === 'primaryCoverage' || type === 'medicaidCoverage' || callInRequired

  const policyOwnerComplete = !defaultStageValidate(
    policyOwnerFieldMap,
    true,
  )(coverage ?? undefined)

  const res: CoverageStageStatus = { incomplete: [], required: ['basic-info'] }
  if (!basicInfoComplete) res.incomplete.push('basic-info')
  if (callInRequired) {
    res.required.push('call-in')
    if (!callInComplete) res.incomplete.push('call-in')
  }

  // if (policyOwnerRequired) {
  res.required.push('policy-owner')
  if (!policyOwnerComplete) res.incomplete.push('policy-owner')
  // }

  return res
}

export const getConfirmCoverageStatus = (
  assessment: PopulatedAssessment | null | undefined,
): ConfirmCoverageStatus => {
  const { plans } = assessment ?? {}
  const { secondary, primary } = plans ?? {}
  const hasPrimary = getHasPrimaryCoverage(assessment?.data?.insuranceInfo)
  const hasSecondary = getHasSecondaryCoverage(assessment?.data?.insuranceInfo)

  // const primaryRequiresCallIn = !primary?.isMedicaid && !primary?.insuranceProvider?.loqNotRequired
  // const secondaryRequiresCallIn =
  //   !primaryRequiresCallIn &&
  //   !secondary?.isMedicaid &&
  //   !secondary?.insuranceProvider?.loqNotRequired

  // call in not required for sign-on (assessment already sent)
  return {
    primaryCoverage: hasPrimary ? getCoverageStatus(primary, false) : null,
    secondaryCoverage: hasSecondary ? getCoverageStatus(secondary, false) : null,
  }
}

export const getAdditionalPlanStatus = (
  p: BaseInsuranceCoverage | undefined,
  request?: InsuranceCoverageRequest,
) => getCoverageStatus(p, false, request)

export const getRequestsStatus = (
  additionalPlans: Record<string, InsuranceCoverageRequest> | undefined,
): Record<string, CoverageStageStatus> => {
  if (!additionalPlans) return {}
  return Object.entries(additionalPlans).reduce(
    (acc, [id, plan]) => ({
      ...acc,
      [id]: getAdditionalPlanStatus(undefined, plan),
    }),
    {},
  )
}
